export const getVoiceValueFromTrigger = (transcript, triggers = []) => {
  transcript = transcript.toLowerCase().trim();
  const matched = triggers.find(trigger => transcript.startsWith(trigger));
  if (matched) {
    return transcript.replace(matched, "").trim();
  }
  return null;
};
